import { useEffect, useState } from 'react';
import { apiClient } from '../../api/client';
import { getTotpRemainingSeconds } from '../../utils/qr';

/**
 * Código 2FA para quem não recebe o segredo do TOTP na listagem (member, ou admin que não criou a
 * credencial). Um clique pede o código atual ao servidor (`POST /credentials/{id}/totp`, que confere
 * as regras de acesso e registra na auditoria); ele some quando o período de 30 s acaba.
 */
export function CodigoDoServidor({ credentialId, compacto = false }: { credentialId: string; compacto?: boolean }) {
  const [codigo, setCodigo] = useState('');
  const [restante, setRestante] = useState(30);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (!codigo) return;
    const atualizar = () => setRestante(getTotpRemainingSeconds(30));
    atualizar();
    const intervalo = setInterval(atualizar, 1000);
    const fim = setTimeout(() => setCodigo(''), getTotpRemainingSeconds(30) * 1000);
    return () => {
      clearInterval(intervalo);
      clearTimeout(fim);
    };
  }, [codigo]);

  const mostrar = async () => {
    setCarregando(true);
    try {
      const resposta = await apiClient.post<{ code?: string }>(`/credentials/${credentialId}/totp`);
      setCodigo(typeof resposta?.code === 'string' ? resposta.code : '');
    } catch {
      setCodigo('');
    } finally {
      setCarregando(false);
    }
  };

  const tamanho = compacto ? 'var(--text-xs)' : 'var(--text-sm)';
  if (codigo) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-2)' }}>
        <code
          style={{
            background: 'var(--color-bg-root)',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: tamanho,
            color: restante <= 5 ? 'var(--color-error, #ef4444)' : 'var(--color-primary-400)',
            fontWeight: 'bold',
            letterSpacing: compacto ? '1.5px' : '2px',
            fontFamily: 'monospace',
          }}
        >
          {codigo.slice(0, 3)} {codigo.slice(3)}
        </code>
        <span style={{ fontSize: tamanho, color: 'var(--color-text-secondary)' }}>{restante}s</span>
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={mostrar}
      disabled={carregando}
      style={{
        background: 'transparent',
        border: '1px solid var(--color-border, rgba(255,255,255,0.15))',
        borderRadius: 'var(--radius-md)',
        color: 'var(--color-primary-400)',
        padding: '2px 8px',
        fontSize: tamanho,
        cursor: carregando ? 'progress' : 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      {carregando ? 'Gerando...' : 'Mostrar código'}
    </button>
  );
}
